<template>
  <div
    class="time-range-picker el-input__wrapper el-date-editor el-date-editor--timerange"
    :class="['el-range-editor--' + size, disabled ? 'is-disabled' : '']"
    @mouseleave="showClose = false"
    @mouseenter="showClose = true"
  >
    <el-icon class="el-icon el-input__icon el-range__icon"><Clock /></el-icon>
    <el-date-picker
      v-model="v1[0]"
      @change="stratHandleValue"
      prefix-icon="a"
      ref="startYear"
      :type="dateType"
      :value-format="valueFormat"
      :size="size"
      :disabled="disabled"
      :picker-options="{
        disabledDate: startDisabledDate
      }"
      :placeholder="startPlaceholder"
      :validate-event="false"
      @blur="inputBlur(v1[0])"
      :clearable="false"
    >
    </el-date-picker>
    <slot name="range-separator">
      <span class="el-range-separator">{{ rangeSeparator }}</span>
    </slot>
    <el-date-picker
      v-model="v1[1]"
      @change="endHandleValue"
      ref="endYear"
      :type="dateType"
      :value-format="valueFormat"
      prefix-icon="a"
      :size="size"
      :disabled="disabled"
      :picker-options="{
        disabledDate: endDisabledDate
      }"
      :placeholder="endPlaceholder"
      :validate-event="false"
      @blur="inputBlur(v1[1])"
      :clearable="false"
    >
    </el-date-picker>

    <el-icon
      class="el-icon el-input__icon el-range__close-icon"
      :class="[showClearable ? '' : 'el-range__close-icon--hidden']"
      @click="handleClickIcon"
    >
      <CircleClose />
    </el-icon>
  </div>
</template>

<script setup lang="ts">
import dayjs from 'dayjs'
import { Clock, CircleClose } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'

const props = defineProps({
  modelValue: {
    type: Array
  },
  disabled: {
    type: Boolean
  },
  dateType: {
    type: String
  },
  valueFormat: {
    type: String
  },
  rangeSeparator: {
    type: String
  },
  startPlaceholder: {
    type: String,
    default: ''
  },
  endPlaceholder: {
    type: String,
    default: ''
  },
  size: {
    type: String
  },
  pickerOptions: {
    type: Object
  },
  clearable: {
    type: Boolean,
    default: true
  }
})

const emits = defineEmits(['update:modelValue'])

let v1 = ref(['', ''])
let showClose = ref(false)
let startYear = ref()
let endYear = ref()

watch(
  () => props.modelValue,
  (n, o) => {
    // 设置参数
    n?.forEach((item, index) => {
      let date = new Date(item)
      if (date.toString() === 'Invalid Date') {
        v1.value[index] = ''
      } else {
        let format = props.valueFormat?.replace('dd', 'DD')
        format = format?.replace('yyyy', 'YYYY')
        //转换为当前组件需要的格式
        v1.value[index] = dayjs(date).format(format)
      }
    })
  },
  {
    immediate: true
  }
)

// 判断是否可以显示清空按钮
const showClearable = computed(
  () =>
    showClose.value &&
    props.clearable &&
    (v1.value[0] != '' || v1.value[1] != '') &&
    !props.disabled
)

// 如果只选一个，将另一个也清空，不允许只选一个
function inputBlur(val) {
  if (val == '') {
    v1.value[0] = ''
    v1.value[1] = ''
  }
}

function handleClickIcon() {
  v1.value[0] = ''
  v1.value[1] = ''
  handleValue()
}

function endHandleValue() {
  if (v1.value[0] === '') {
    startYear.value.focus()
  } else {
    handleValue()
  }
}

function stratHandleValue() {
  if (v1.value[1] === '') {
    endYear.value.focus()
  } else {
    handleValue()
  }
}

function handleValue() {
  let date = ['', '']
  if (v1.value[0] !== '' && v1.value[1] !== '') {
    if (new Date(v1.value[1]).getTime() < new Date(v1.value[0]).getTime()) {
      ElMessage.error(`${props.endPlaceholder}不能小于${props.startPlaceholder}`)
    } else {
      date = [v1.value[0], v1.value[1]]
    }
  }

  emits('update:modelValue', date)
}

function startDisabledDate(time) {
  if (props.pickerOptions?.startDisabledDate) {
    return props.pickerOptions.startDisabledDate(time, v1.value[0], v1.value[1])
  } else {
    if (v1.value[1] === '') {
      return false
    } else {
      return time > new Date(v1.value[1])
    }
  }
}

function endDisabledDate(time) {
  if (props.pickerOptions?.endDisabledDate) {
    return props.pickerOptions.endDisabledDate(time, v1.value[0], v1.value[1])
  } else {
    if (v1.value[0] === '') {
      return false
    } else {
      return time < new Date(v1.value[0].slice(0, 10) + ' 00:00:00')
    }
  }
}
</script>
<style lang="scss"></style>
